<template>
<div data-component="DummyElement.vue"/>
</template>

<script lang="ts">
// @vuese
// Pusty komponent wysyłający zdarzenia `mounted` i `created`.
// @group Base Components
export default {
	name: 'DummyElement',
	emits: ['mounted', 'created'],
	mounted() { this.$emit('mounted'); },
	created() { this.$emit('created'); },
};
</script>
